
// Folds a string at a specified length, optionally attempting
// to insert newlines after whitespace characters.
//
// s          -  input string
// n          -  number of chars at which to separate lines
// useSpaces  -  if true, attempt to insert newlines at whitespace
// a          -  array used to build result
//
// Returns an array of strings that are no longer than n
// characters long.  If a is specified as an array, the lines 
// found in s will be pushed onto the end of a. 
//
// If s is huge and n is very small, this metho will have
// problems... StackOverflow.
//
// Sourced From: https://stackoverflow.com/questions/17895039/how-to-insert-line-break-after-every-80-characters

export var Fold = function fold(string:string, num:number, useSpaces:boolean, a?:Array<any>) {
    a = a || [];
    if (string.length <= num) {
        a.push(string);
        return a;
    }
    var line = string.substring(0, num);
    if (! useSpaces) { // insert newlines anywhere
        a.push(line);
        return fold(string.substring(num), num, useSpaces, a);
    }
    else { // attempt to insert newlines after whitespace
        var lastSpaceRgx = /\s(?!.*\s)/;
        var idx = line.search(lastSpaceRgx);
        var nextIdx = num;
        if (idx > 0) {
            line = line.substring(0, idx);
            nextIdx = idx;
        }
        a.push(line);
        return fold(string.substring(nextIdx), num, useSpaces, a);
    }
}